export function setupProfileLabel(profile) {
  if (profile === 'SAFE') return 'Güvenli'
  if (profile === 'BALANCED') return 'Dengeli'
  if (profile === 'FAST') return 'Hızlı'
  return profile || '-'
}

export function setupRiskBandLabel(band) {
  if (band === 'EXTREME') return 'Aşırı risk'
  if (band === 'HIGH') return 'Yüksek risk'
  if (band === 'MEDIUM') return 'Orta risk'
  if (band === 'LOW') return 'Düşük risk'
  return band || '-'
}

export function setupHealthBadgeVariant(band) {
  if (band === 'EXTREME') return 'danger'
  if (band === 'HIGH') return 'warning'
  if (band === 'MEDIUM') return 'info'
  return 'success'
}

export function setupHealthProfileSummary(profile) {
  if (profile === 'SAFE') {
    return [
      'Koruma öncelikli.',
      'Risk düşük, TP/SL sıkı.',
      'Sakin büyüme isteyen kurulumlara uygun.',
    ]
  }
  if (profile === 'FAST') {
    return [
      'Daha agresif.',
      'Runner alanı geniş, tolerans daha esnek.',
      'Daha hızlı büyüme ve daha yüksek dalgalanma kabul edenler için.',
    ]
  }
  return [
    'Denge odaklı.',
    'Koruma ve büyüme arasında orta ayar.',
    'Genel kullanım için güvenli başlangıç noktası.',
  ]
}

export function setupHealthActionHint(profile) {
  if (profile === 'SAFE') return 'Önce riski sabitle, sonra büyüt.'
  if (profile === 'FAST') return 'Önce fırsatı genişlet, sonra korumayı ayarla.'
  return 'Önce dengeyi koru, sonra ince ayar yap.'
}
